
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/--roboneo/ai_enhance",
      function () {
        return require("private-next-pages/--roboneo/ai_enhance/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/--roboneo/ai_enhance"])
      });
    }
  